/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { API_CONFIG } from "../Config/config-env.js";
import { Navigate } from "react-router-dom";
import Loader from "../components/Loader";
import TopBar from "../components/TopBar";
const Home = () => {
  const { qr_id } = useParams();

  // Renderiza el componente de clase Home y pasa los parámetros de la URL como props
  return <Class qr_id={qr_id} />;
};

class Class extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      qr_id: "",
      amount: 0,
      order_id: "",
      isValid: true,
      company_name: "",
      card_expiry_date: "",
      loading: true,
      URLCYBER: "",
      invalid: false,
      image_path: "",
    };
  }

  componentDidMount = async () => {
    console.log(this.props);
    const { qr_id } = this.props;
    
    await axios({
      url: API_CONFIG.base_url + "/validateQr",
      data: {
        qr_id: qr_id,
      },
      method: "post",
      dataType: "json",
    })
      .then((response) => response.data)
      .then((data) => { 
        this.setState({
           loading: false,
        });

        if (data.status) {
          this.setState({
            company_code: data.data.qr_source,
            amount: data.data.amount,
            order_id: data.data.order_id,
            image_path: data.data.image_path,
          });
        } else {
          if (data.code === "REDIRET") {
            console.log("aqui");
            this.setState({
              redirect: true,
              company_code: data.data.qr_source,
              qr_id: data.data.id,
            });
          } else {
            this.setState({
              invalid: true,
            });
          }
        }
      })
      .catch(function (error) {
        this.setState({
          invalid: true,
        });
        console.log(">>>>>>>>", error);
      });
  };

  renderRedirect = () => {
    if (this.state.redirect) {
      return (
        <Navigate
          to={
            "/api/v1/request/" +
            this.state.company_code +
            "/" +
            this.state.qr_id
          }
        />
      );
    }
  };

  render() {
    return (
      <>
        <Loader idLoading={this.state.loading} />
        {this.renderRedirect()}
        <TopBar subtitle="Confirmación de pago" />
        {this.state.invalid ? (
          <div className="xp-page">
            <div className="xp-card">
              <div className="xp-badge xp-badge-neutral">
                <i className="fas fa-search"></i>
              </div>
              <h2>No encontramos su reserva</h2>
              <p className="xp-sub">
                Verifique el enlace recibido o vuelva a intentarlo desde el
                correo de su reserva.
              </p>
              <div className="xp-trust">
                <i className="fas fa-lock"></i> Pago seguro · Transacción
                protegida
              </div>
            </div>
          </div>
        ) : (
          <div className="xp-page">
            {!this.state.loading && (
              <div className="xp-card">
                <div className="xp-badge xp-badge-success">
                  <i className="fas fa-check"></i>
                </div>
                <h2>¡Pago exitoso!</h2>
                <p className="xp-sub">
                  Tu reserva quedó confirmada. Te enviamos un correo con la
                  confirmación del pago.
                </p>
                <div className="xp-summary">
                  <div className="xp-summary-row">
                    <span>Nro. de reserva</span>
                    <b>{this.state.order_id}</b>
                  </div>
                  <div className="xp-summary-row">
                    <span>Monto pagado</span>
                    <b className="xp-amount">
                      Bs {this.state.amount.toFixed(2)}
                    </b>
                  </div>
                </div>
                <div className="xp-note">
                  <i className="fas fa-concierge-bell"></i>
                  <span>¡Te esperamos! Que disfrutes tu estadía.</span>
                </div>
                {this.state.image_path !== "" && (
                  <div style={{ textAlign: "center" }}>
                    <img className="image-logo" src={this.state.image_path} />
                  </div>
                )}
                <div className="xp-trust">
                  <i className="fas fa-lock"></i> Pago seguro · Transacción
                  protegida
                </div>
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}
export default Home;
